<script setup lang="ts">
const {collectionUri, pageUri} = useI18nCollection();

const config = useRuntimeConfig().public;

const page = await queryCollection(collectionUri('home')).path(pageUri('home/brand')).first();
const pageAbout = await queryCollection(collectionUri('home')).path(pageUri('home/about')).first();

const imgUriList = computed<string[]>(() => (page.meta?.images || []).map((i: string) => i.replace('/assets', '')));
const ctaList = computed(() => page.meta?.cta || []);
const aboutImgUri = computed<string>(() => (pageAbout.meta?.image || '').replace('/assets', ''));
</script>

<template>
  <div class="container spacer-section tablet:grid tablet:grid-cols-2 gap-x-6">
    <article class="tablet:flex tablet:items-stretch justify-center bg-light block-round flex-row-reverse gap-x-8">
      <div class="text-brand-dark p-4 tablet:p-0 tablet:flex flex-col justify-center font-sans">
        <header>
          <h3 class="article-title mb-4">{{ pageAbout.title }}</h3>
        </header>
        <ContentRenderer :value="pageAbout" class="with-free-text" />
        <div class="flex flex-wrap gap-4 mb-8 tablet:mb-0">
          <ButtonCta v-for="cta in pageAbout.meta?.cta || []" :key="cta.label" :cta="cta" class="border-dotted border-b text-secondary" />
        </div>
      </div>
      <figure v-if="aboutImgUri" class="basis-2/5 shrink-0 gap-2 w-full relative tablet:self-stretch">
        <picture
                class="w-full relative block aspect-[0.9] tablet:aspect-auto tablet:h-full rounded-2xl overflow-hidden"
        >
          <media-source
                  :uri="aboutImgUri"
                  :expose-only="false"
                  :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
                  sizes="100vw"
                  :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
                  format="webp"
                  as="source"
          />
          <media-source
                  :uri="aboutImgUri"
                  :expose-only="false"
                  :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
                  sizes="100vw"
                  format="jpg"
                  as="img"
                  class="w-full h-full object-cover relative z-1"
          />
        </picture>
      </figure>
    </article>
    <article class="tablet:flex tablet:items-stretch justify-center bg-light block-round flex-row-reverse gap-x-8">
      <div class="text-brand-dark p-4 tablet:p-0 tablet:flex flex-col justify-center font-sans">
        <header>
          <h3 class="article-title mb-4">{{ page.title }}</h3>
        </header>
        <ContentRenderer :value="page" class="with-free-text" />
        <div class="flex flex-wrap gap-4 mb-8 tablet:mb-0">
          <ButtonCta v-for="cta in ctaList" :key="cta.label" :cta="cta" class="border-dotted border-b text-secondary" />
        </div>
      </div>
      <figure v-if="imgUriList.length > 0" class="basis-2/5 shrink-0 grid grid-cols-2 tablet:auto-rows-fr gap-2 w-full relative tablet:self-stretch">
        <picture
                v-for="imgUri in imgUriList"
                :key="imgUri"
                class="w-full relative block aspect-[0.9] tablet:aspect-auto tablet:h-full rounded-2xl overflow-hidden"
        >
          <media-source
                  :uri="imgUri"
                  :expose-only="false"
                  :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
                  sizes="100vw"
                  :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
                  format="webp"
                  as="source"
          />
          <media-source
                  :uri="imgUri"
                  :expose-only="false"
                  :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
                  sizes="100vw"
                  format="jpg"
                  as="img"
                  class="w-full h-full object-cover relative z-1"
          />
        </picture>
      </figure>
    </article>
  </div>
</template>
